import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Inner from '../../components/Inner'
import Title from '../../components/Title'
import { articlesApi } from '../../api'
import { VideoPlayer } from '../collections/VideoPlayer'
import { Helmet } from 'react-helmet-async'


function Articles() {
    const { t } = useTranslation()
    const [articles, setArticles] = useState([])

    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const data = await articlesApi.list({ is_shown: true })
                setArticles(data)
            } catch (e) {
                setArticles([])
            }
        }
        fetchArticles()
    }, [])

    return (<>
        <Helmet>
            <title>News & Articles | Belsky Art Gallery</title>
            <meta name="description" content="Read the latest news and articles about contemporary art and Eduard Belsky's works." />
            <link rel="canonical" href="https://eduardbelsky.com/news" />
            <meta name="robots" content="index, follow" />
            <meta property="og:title" content="News & Articles | Belsky Art Gallery" />
            <meta property="og:description" content="Read the latest news and articles about contemporary art and Eduard Belsky's works." />
            {/* <meta property="og:image" content="https://eduardbelsky.com/images/og-news.jpg" /> */}
            <meta property="og:image" content="%PUBLIC_URL%/logo192.png" />
            <meta property="og:url" content="https://eduardbelsky.com/news" />
        </Helmet>
        <h1 className="sr-only">News</h1>
        <Inner>
            <Title>{t('News')}</Title>
            <div className="flex flex-col gap-8 py-8">
                {articles.map((article, idx) => (
                    <div
                        key={article.id}
                        className={`block pb-6${idx !== articles.length - 1 ? ' border-b' : ''}`}
                    >
                        <h2 className="text-2xl font-semibold mb-2">{article.title}</h2>
                        {article.created_at && (
                            <div className="text-sm text-gray-500 mb-2">
                                {new Date(article.created_at).toLocaleDateString()}
                            </div>
                        )}
                        <div className="text-base text-gray-700">
                            {article.content
                                .split(/\r?\n/)
                                .filter(paragraph => paragraph.trim() !== '')
                                .map((paragraph, i, arr) => (
                                    <p
                                        key={i}
                                        className={i !== arr.length - 1 ? "mb-2" : undefined}
                                    >
                                        {paragraph}
                                    </p>
                            ))}
                        </div>
                        {article.images_urls?.length > 0 && (
                            <div className="flex flex-wrap gap-4 mb-4">
                                {article.images_urls.map((imgArr, imgIdx) => {
                                    const imgUrl = imgArr[0];
                                    return imgUrl ? (
                                        <img
                                            key={imgUrl + imgIdx}
                                            src={imgUrl}
                                            alt={article.title}
                                            className="max-w-xs max-h-80 rounded"
                                        />
                                    ) : null;
                                })}
                            </div>
                        )}
                        {article.video_url && (
                            <div className="mt-4">
                                <VideoPlayer src={article.video_url} className="max-w-full rounded" />
                            </div>
                        )}
                    </div>
                ))}
                {articles.length === 0 && <div>{t('No news articles found.')}</div>}
            </div>
        </Inner>
    </>
    )
}

export default Articles
